import { render, staticRenderFns } from "./assetcheckviewdata.html?vue&type=template&id=5388acba&scoped=true&external"
import script from "./assetcheckviewdata.vue?vue&type=script&lang=js"
export * from "./assetcheckviewdata.vue?vue&type=script&lang=js"
import style0 from "./assetcheckviewdata.vue?vue&type=style&index=0&id=5388acba&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5388acba",
  null
  
)

export default component.exports